import React from 'react'
import PropTypes from 'prop-types'
import { map } from 'lodash'
import classNames from 'classnames'
import Tappable from 'react-tappable'
import Image from 'components/image'
import * as css from './thumbnail-selector.scss'

const ThumbnailSelector = ({ value, thumbnails, onClick, className, name }) => (
  <div aria-label={`${name} options`} role="radiogroup" className={className}>
    {map(thumbnails, (thumbnail) => (
      <Thumbnail
        key={thumbnail.url}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...thumbnail}
        active={value === thumbnail.value}
        onClick={onClick}
      />
    ))}
  </div>
)

ThumbnailSelector.propTypes = {
  thumbnails: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  value: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
}

ThumbnailSelector.defaultProps = {
  className: '',
}

export const Thumbnail = ({
  value,
  active,
  url,
  onClick,
  disabled,
  className,
  activeClass,
}) => {
  const activeClassName = activeClass || css.active
  return (
    <Tappable
      role="radio"
      aria-label={value}
      aria-checked={active}
      tabIndex={active ? 0 : -1}
      component="button"
      onClick={() => onClick(value)}
      className={classNames(
        css.thumbnail,
        'btn-unstyled',
        'btn-block',
        {
          [css.disabled]: disabled,
          [activeClassName]: active,
        },
        className
      )}
    >
      <Image alt={value} className="img-responsive" src={url} pinterest />
    </Tappable>
  )
}

Thumbnail.propTypes = {
  value: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  activeClass: PropTypes.string,
}

Thumbnail.defaultProps = {
  active: false,
  disabled: false,
  className: '',
  activeClass: '',
}

export default ThumbnailSelector
